import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getNotifications } from '../api';
import { useAuth } from '../auth';

export default function PWABadge() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
    refetchInterval: 30_000,
    enabled: !!user,
  });
  useEffect(() => {
    if (typeof navigator === 'undefined') return;
    const setBadge = (navigator as any).setAppBadge?.bind(navigator);
    const clearBadge = (navigator as any).clearAppBadge?.bind(navigator);
    if (!setBadge || !clearBadge) return;
    const unread = data?.unread ?? 0;
    if (unread > 0) setBadge(unread).catch(() => {});
    else clearBadge().catch(() => {});
  }, [data]);
  return null;
}
